import { createContext, CSSProperties } from "react";

export enum Measure {
  ML = "ML",
  OZ = "OZ"
}

export const MeasureLabels = {
  [Measure.ML]: "ml",
  [Measure.OZ]: "fl oz"
} as const;

export interface HistoryItem {
  timestamp: number;
  amount: number;
  measure: Measure;
}

export type Amount = number;

export const DEFAULT_MEASURE = Measure.ML;

export const DEFAULT_DAILY_GOAL: Amount = 2100;

export const DEFAULT_AMOUNT: Amount = 300;

// For nutrition labeling purposes ... 1 fl oz means 30 mL ...
// https://www.ecfr.gov/cgi-bin/text-idx?node=se21.2.101_19
export const ML_IN_OZ = 30;

export interface WavesStyle {
  container: CSSProperties["height"];
  wave: CSSProperties["height"];
}

export interface AppContextValues {
  isReady: boolean;
  lastAmount: Amount,
  todayAmount: Amount;
  todayProgress: number;
  configMeasure: Measure;
  configGoal: Amount;
}

export const DEFAULT_CONTEXT_VALUES: AppContextValues = {
  isReady: false,
  lastAmount: DEFAULT_AMOUNT,
  todayAmount: 0,
  todayProgress: 0,
  configMeasure: DEFAULT_MEASURE,
  configGoal: DEFAULT_DAILY_GOAL
}

export interface AppContextMethods {
  addDrink?: (amount: Amount) => void;
  removeDrink?: (item: HistoryItem) => Promise<void>;
  setDailyGoalAndMeasure?: (amount: Amount, measure: Measure) => void;
}

export interface AppContext extends AppContextValues, AppContextMethods { }

export const Context = createContext<AppContext>(DEFAULT_CONTEXT_VALUES);

export interface CacheContextValues {
  previousWavesStyle: WavesStyle;
  previousRouteTitle: string;
  nextStepAnimationSkip: boolean;
  isScreenFilled: boolean;
}

export const DEFAULT_CACHE_CONTEXT_VALUES: CacheContextValues = {
  previousWavesStyle: {
    container: 0,
    wave: 0
  },
  previousRouteTitle: "",
  nextStepAnimationSkip: false,
  isScreenFilled: false
}

export interface CacheContextMethods {
  setPreviousWavesStyle?: (value: WavesStyle) => void;
  setPreviousRouteTitle?: (value: string) => void;
  setScreenFilled?: (value: boolean) => void;
}

export interface CacheContext extends CacheContextValues, CacheContextMethods { }

export const Cache = createContext<CacheContext>(DEFAULT_CACHE_CONTEXT_VALUES);